import {getRequest} from "../common/utils";

export function getShopByUserId(criteria){
    return getRequest(`/account-shop`, criteria)
}